(() => {
  if (window.NWCompactSavedProducts) return;
  window.NWCompactSavedProducts = true;
  const dialog = document.querySelector('#NWSavedProducts');
  if (!dialog) return;
  const config = JSON.parse(document.querySelector('#NWSavedConfig').textContent);
  const t = config.strings, key = 'neoware_wishlist';
  const content = dialog.querySelector('[data-nw-saved-content]');
  const toast = document.querySelector('[data-nw-saved-toast]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const urls = new Map(), cards = new Map();
  let controller, opener, closeTimer, toastTimer, revision = 0;
  let nextIndex = config.all, indexComplete = false;
  function saved() {
    try { const ids = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(ids) ? [...new Set(ids.map(String))] : []; }
    catch { return []; }
  }
  let previous = saved();
  function sync() {
    const ids = saved();
    document.querySelectorAll('[data-wishlist-link]').forEach(button => {
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'NWSavedProducts');
      button.setAttribute('aria-expanded', String(dialog.open));
      button.setAttribute('aria-label', t.title);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(count => {
      const value = String(ids.length);
      if (count.textContent !== value) count.textContent = value;
      count.hidden = !ids.length;
    });
    document.querySelectorAll('[data-wishlist-toggle], [data-nsc-wishlist-toggle], [data-save]').forEach(button => {
      const on = ids.includes(button.dataset.productId || button.dataset.save);
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', String(on));
    });
  }
  function discoverUrls() {
    document.querySelectorAll('[data-wishlist-toggle], [data-nsc-wishlist-toggle], [data-save]').forEach(button => {
      const id = button.dataset.productId || button.dataset.save;
      const card = button.closest('.psc-card, .dg-card, .hmp-card, [data-nsc-card], [data-product-section]');
      const url = card?.dataset.productUrl || card?.querySelector('a[href*="/products/"]')?.getAttribute('href');
      if (id && url) urls.set(id, url);
    });
  }
  async function html(url, section, signal) {
    const target = new URL(url, location.origin);
    if (target.origin !== location.origin) throw new Error(t.error);
    target.searchParams.set('section_id', section);
    const response = await fetch(target, { signal });
    if (!response.ok) throw new Error(t.error);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async function resolve(ids, signal) {
    discoverUrls();
    const visited = new Set();
    while (ids.some(id => !urls.has(id)) && !indexComplete) {
      if (visited.has(nextIndex)) throw new Error(t.error);
      visited.add(nextIndex);
      const doc = await html(nextIndex, 'nw-saved-products-index', signal);
      const node = doc.querySelector('[data-nw-saved-index]');
      if (!node) throw new Error(t.error);
      const data = JSON.parse(node.textContent);
      data.products.forEach(product => urls.set(String(product.id), product.url));
      nextIndex = data.next;
      indexComplete = !nextIndex;
    }
  }
  function message(text, retry = false) {
    const p = document.createElement('p');
    p.className = 'nw-saved-message'; p.textContent = text;
    if (retry) {
      const button = document.createElement('button'); button.type = 'button';
      button.className = 'nw-saved-retry'; button.textContent = 'Try again';
      button.addEventListener('click', () => { nextIndex = config.all; indexComplete = false; render(); });
      p.append(button);
    }
    return p;
  }
  async function render() {
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal, current = ++revision, ids = saved();
    const activeId = document.activeElement?.closest('[data-nw-saved-id]')?.dataset.nwSavedId;
    // Keep existing cards stable while resolving newly saved products.
    content.querySelectorAll('[data-nw-saved-id]').forEach(card => { if (!ids.includes(card.dataset.nwSavedId)) card.remove(); });
    content.querySelectorAll('.nw-saved-message').forEach(node => node.remove());
    if (!ids.length) { content.replaceChildren(message(t.empty)); content.setAttribute('aria-busy', 'false'); if (activeId) dialog.querySelector('[data-nw-saved-close]').focus(); return; }
    content.setAttribute('aria-busy', 'true');
    if (!content.children.length) content.append(message(t.loading));
    try {
      await resolve(ids, signal);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(4, ids.length) }, async () => {
        while (cursor < ids.length) {
          const id = ids[cursor++];
          if (cards.has(id) || !urls.has(id)) continue;
          try {
            const doc = await html(urls.get(id), 'nw-saved-product-card', signal);
            const card = doc.querySelector('[data-nsc-card]');
            if (card) { card.dataset.nwSavedId = id; cards.set(id, card); }
          } catch (error) { if (error.name === 'AbortError') throw error; }
        }
      }));
      if (current !== revision || signal.aborted) return;
      content.querySelectorAll('.nw-saved-message').forEach(node => node.remove());
      for (const id of ids) {
        if (!cards.has(id)) continue;
        const existing = [...content.children].find(node => node.dataset.nwSavedId === id);
        content.append(existing || cards.get(id).cloneNode(true));
      }
      if (ids.some(id => !cards.has(id))) content.append(message(t.error, true));
      sync();
      if (activeId && !ids.includes(activeId)) dialog.querySelector('[data-nw-saved-close]').focus();
    } catch (error) {
      if (error.name !== 'AbortError' && current === revision) {
        content.querySelectorAll('.nw-saved-message').forEach(node => node.remove());
        content.append(message(t.error, true));
      }
    } finally { if (current === revision) content.setAttribute('aria-busy', 'false'); }
  }
  function close() {
    if (!dialog.open) return;
    controller?.abort(); ++revision;
    dialog.classList.remove('is-visible'); clearTimeout(closeTimer);
    closeTimer = setTimeout(() => { dialog.close(); if (opener?.isConnected) opener.focus({ preventScroll: true }); }, reduced.matches ? 0 : 240);
  }
  function open(button) {
    clearTimeout(closeTimer); opener = button;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('nw-saved-open');
    requestAnimationFrame(() => requestAnimationFrame(() => { if (dialog.open) dialog.classList.add('is-visible'); }));
    sync(); render();
  }
  window.addEventListener('click', event => {
    const button = event.target.closest('[data-wishlist-link]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(button);
  }, true);
  dialog.querySelector('[data-nw-saved-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('nw-saved-open'); sync(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.addEventListener('wishlist:updated', () => {
    const ids = saved();
    if (ids.join(',') !== previous.join(',')) {
      toast.textContent = ids.some(id => !previous.includes(id)) ? t.saved : t.removed;
      // Native dialogs are in the top layer; place feedback in the active dialog.
      const top = [...document.querySelectorAll('dialog[open]')].find(node => node.id === 'NWStudioQuickview') || (dialog.open ? dialog : document.body);
      top.append(toast); toast.hidden = false; clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 2400);
      previous = ids;
      sync(); if (dialog.open) render();
    } else sync();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    previous = saved(); sync(); if (dialog.open) render();
  });
  document.addEventListener('cart:update', event => {
    if (dialog.open && event.detail?.sourceId === 'nw-studio-quickview' && event.detail?.data?.sections) close();
  });
  const savedControls = '[data-wishlist-link], [data-wishlist-count], [data-wishlist-toggle], [data-nsc-wishlist-toggle], [data-save]';
  let syncFrame = 0;
  new MutationObserver(records => {
    if (syncFrame || !records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches(savedControls) || node.querySelector(savedControls))
    ))) return;
    syncFrame = requestAnimationFrame(() => { syncFrame = 0; sync(); });
  }).observe(document.body, {childList:true, subtree:true});
  sync();
})();
